import React from "react";

import "./DreamCard.scss";

export default function DreamCard() {
  return (
    <div className="custom_card dream_card">
      <h4>Want to achieve your dream?</h4>
      <button className="button button_primary">Enrol now</button>
    </div>
  );
}
